import styled from 'styled-components'

const CTABtn = styled.button`
  height: 56px;
  font-size: 1.25rem;
  margin-top: 24px;
  padding: 0px 43px;
  float: left;
  border-radius: 12px;
  width: auto !important;
`

export default CTABtn
